module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_m_normal.3be896f1.png";